import { ComponentConfig } from '@measured/puck';
import CustomTooltip from '../../../components/common/tooltip';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import { WidthProps, widthField } from '../../puck/reusable-props/width';
import { PaddingProps, paddingFields } from '../../puck/reusable-props/padding';
import {
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  getQuillEditorText,
} from '../../utils/helper';
import { ReduxSelectorProps } from '../../services/constants';
import showComponent, {
  showComponentProps,
} from '../../puck/reusable-props/showComponent';
import { resolveShowComponentField, getBorderProps } from '../../utils/helper';
import './../text-editor/style.scss';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { QuillTextEditor } from '../../puck/reusable-props/quill-editor';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';

export type TextFieldProps = {
  header: string;
  dividerLine: boolean;
  border: IBorderValueProps;
  background: {
    color: string;
    isInherit: boolean;
  };
} & MarginProps &
  showComponentProps &
  WidthProps &
  PaddingProps;

export const TextField = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<TextFieldProps> => {
  return {
    label: (
      <CustomTooltip title="TextField">
        <span>Text Field</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      header: {
        ...QuillTextEditor('Content').content,
      },
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      ...backgroungFields,
      dividerLine: {
        type: 'radio',
        label: 'Divider Line',
        options: [
          { value: true, label: 'Yes' },
          { value: false, label: 'No' },
        ],
      },
      ...widthField,
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      ...borderProps,
      header:
        '<p style="line-height:1.5;"><span style="font-size: 16px;">Text Field</span></p>',
      dividerLine: false,
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      width: 'auto',
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      margin,
      header,
      padding,
      width,
      border,
      background,
      showComponent,
      dividerLine,
      editMode,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      const state = useAppSelector(state => state);
      const newInterpolation = getQuillEditorText(header, state);

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div className="text-editor-content remove-line-height items-center flex">
              {dividerLine && (
                <div className="flex-grow border-t border-black" />
              )}
              <div
                className={`${width} ${margin?.desktop?.top} ${margin?.desktop?.bottom} ${margin?.desktop?.left} ${margin?.desktop?.right}
              ${margin?.tablet?.top} ${margin?.tablet?.bottom} ${margin?.tablet?.left} ${margin?.tablet?.right}
              ${margin?.mobile?.top} ${margin?.mobile?.bottom} ${margin?.mobile?.left} ${margin?.mobile?.right} ${border?.borderStyle?.[currentDeviceType]}`}
                style={{
                  ...marginStyles,
                  backgroundColor: background?.isInherit
                    ? 'inherit'
                    : background?.color,
                  ...getPaddingStyles(padding, currentDeviceType),
                  ...getBorderProps(border, currentDeviceType),
                  transition: 'background-color 0.3s',
                  lineHeight: 1.5,
                }}
                dangerouslySetInnerHTML={{ __html: newInterpolation }}
              />
              {dividerLine && (
                <div className="flex-grow border-t border-black" />
              )}
            </div>
          )}
        </>
      );
    },
  };
};
